module.exports = __webpack_public_path__ + "static/img/应用场景2-智能座舱.f496162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-4/应用场景2-智能座舱.png
// module id = E9wj
// module chunks = 0